import { CHART_VARIANT } from '../constants.js';
import {
  PIE_INTERNAL_RADIUS,
  LABEL_FONT_SIZE,
  LABEL_FONT_SIZE_MULTIPLIER,
  DONUT_INTERNAL_RADIUS,
} from '../types/default.js';
import {
  InternalSliceData,
  type ChartVariant,
} from '../types/internal/pie-chart.js';

export const buildChartSizes = (
  height: number,
  width: number,
  variant: ChartVariant,
  data: InternalSliceData[],
  hiddenLabels: boolean,
) => {
  const topCenter = height / 2;
  const labelsPadding = hiddenLabels
    ? 0
    : LABEL_FONT_SIZE * LABEL_FONT_SIZE_MULTIPLIER;
  const radius = Math.min(width, height) / 2 - labelsPadding;

  const donutInnerRadius = radius * DONUT_INTERNAL_RADIUS;
  const pieInnerRadius = data.length > 1 ? PIE_INTERNAL_RADIUS : 0;
  const innerRadius =
    variant === CHART_VARIANT.Donut ? donutInnerRadius : pieInnerRadius;

  const leftCenter = width / 2;

  return { topCenter, radius, innerRadius, leftCenter };
};
